var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name !== 'Home')?_c('v-footer',{attrs:{"align-content-center":"","app":"","color":"primary"}},[_c('span',{staticClass:"white--text mx-auto"},[_vm._v("InfiniteTodos (v1.0) © "+_vm._s(new Date().getFullYear()))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }